/* Kickstarter 成绩气泡的轮播。见 snippets/pexar-ks-ticker.liquid。

   节奏是「停留 → 淡出 → 空一拍 → 下一颗浮上来」，不是交叉淡入淡出。停留时长来自主题设置，
   淡出时长和空拍来自 CSS 变量。空这一拍是刻意的：
   相邻两条文案长短不同，两颗宽度不一样的气泡叠在一起淡入淡出会糊成一团，中间断开才有
   "一颗一颗冒出来"的感觉。

   一个页面上可能有两份气泡（桌面端在 slide 右下角，手机端在文案下方，两份用媒体查询
   互斥显示），所以这里共用一套计时 —— 两边永远停在同一条，切换断点时不会看到两句不同的。

   文案全部由 Liquid 直出在 DOM 里，JS 只切 is-active / is-leaving 两个类。JS 挂了就停在
   第一颗上，气泡本身和它的链接照常可用。 */

(function () {
  'use strict';

  var nodes = [].slice.call(document.querySelectorAll('[data-kst]'));
  if (!nodes.length) return;

  /* 进出场时长和空拍都从 CSS 读（.kst 上的 --kst-fade / --kst-gap），不在这里另存一份。
     两边各存一份常量的话，改了 CSS 忘了改这里，下一颗会在上一颗还没淡完时冒出来，
     两颗宽度不同的气泡叠在一起。

     CSS 时长可以写成秒或毫秒，这里按单位换算。读不到就退回一组能用的默认值。 */
  function readMs(name, fallback) {
    var raw = String(getComputedStyle(nodes[0]).getPropertyValue(name)).trim();
    var n = parseFloat(raw);
    if (!isFinite(n) || n <= 0) return fallback;
    return /ms$/.test(raw) ? n : n * 1000;
  }

  var EXIT = readMs('--kst-fade', 750);
  var GAP = readMs('--kst-gap', 140);

  var count = 0;
  nodes.forEach(function (n) {
    var c = n.querySelectorAll('[data-kst-msg]').length;
    if (c > count) count = c;
  });
  // 只有一颗气泡时没有"轮播"可言，让它静静待着
  if (count < 2) return;

  var hold = parseInt(nodes[0].getAttribute('data-kst-interval'), 10) || 4000;

  var index = 0;
  var tHold = null;
  var tSwap = null;
  var paused = false;

  function each(fn) {
    nodes.forEach(function (n) {
      var msgs = n.querySelectorAll('[data-kst-msg]');
      // 两份气泡的条数理论上一致，取模只是防一份被单独改坏时越界
      for (var i = 0; i < msgs.length; i++) fn(msgs[i], i, msgs.length);
    });
  }

  // 当前这颗开始往上淡出，其余保持隐藏
  function leave() {
    each(function (el, i, len) {
      el.classList.remove('is-active');
      el.classList.toggle('is-leaving', i === index % len);
    });
  }

  // 下一颗从下面浮上来。上一颗的 is-leaving 在这里摘掉 —— 那时它已经 visibility: hidden，
  // 跳回待播位看不见，不需要额外压制过渡。
  function enter() {
    each(function (el, i, len) {
      el.classList.remove('is-leaving');
      el.classList.toggle('is-active', i === index % len);
    });
  }

  function clearTimers() {
    clearTimeout(tHold);
    clearTimeout(tSwap);
    tHold = tSwap = null;
  }

  function step() {
    /* 悬停、键盘聚焦、或者标签页切走了 —— 让当前这颗停着，别在没人看的时候空转，
       也别在读的人还没读完时换掉。250ms 再回来看一眼，比等满一个 hold 反应快。 */
    if (paused || document.hidden) {
      tHold = setTimeout(step, 250);
      return;
    }

    leave();
    tSwap = setTimeout(function () {
      index = (index + 1) % count;
      enter();
      tHold = setTimeout(step, hold);
    }, EXIT + GAP);
  }

  /* 主题编辑器里改一次设置就重渲染整个 section，脚本标签跟着重新执行。上一轮的计时器
     还在跑，指着已经被移除的节点 —— 不清掉就会越叠越多。 */
  if (window.__kstStop) window.__kstStop();
  window.__kstStop = clearTimers;

  nodes.forEach(function (n) {
    n.addEventListener('mouseenter', function () { paused = true; });
    n.addEventListener('mouseleave', function () { paused = false; });
    n.addEventListener('focusin', function () { paused = true; });
    n.addEventListener('focusout', function () { paused = false; });
  });

  enter();
  tHold = setTimeout(step, hold);
})();
